module.exports = __webpack_public_path__ + "static/media/logo_mosty.4e20e841.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_mosty.svg
// module id = 738
// module chunks = 0